/*
 * Created with vue 2
 * Author: Jay/jaytanweb@163.com
 * Date: 2018/4/18
 * Time: 17:14
 */
<template>
  <div class='simpleCarouselItem'>
    <slot name="carouselImages"></slot>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'simpleCarouselItem',
  props: {},
  data () {
    return {}
  },
  components: {},
  methods: {},
  mounted () {
    // simpleCarouselItem mounted
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.simpleCarouselItem {
  //begin you code
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 50px;
  display: inline-block;
  overflow-y: auto;
  transition: transform .4s, opacity .4s;
  z-index: 0;
  background: #000;
  img {
    position: relative;
    width: 100%;
    min-height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/simple/sp-carousel-item.vue